/**
 * Types of funds - Used to determine the sorting order in Valuation Summary.
 */

export enum FundType {
  MainFundCoinvestment = 'Main Fund + Co-investment',
  PartnersSmas = 'Partners + SMAs',
  DirectCoinvestment = 'Direct Co-investment',
  Others = 'Others',
}
